// AdditionalDetailsStep.tsx
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { TrainingInput } from "./types";

interface AdditionalDetailsStepProps {
  newTraining: Partial<TrainingInput>;
  setNewTraining: (training: Partial<TrainingInput>) => void;
}

const AdditionalDetailsStep: React.FC<AdditionalDetailsStepProps> = ({ 
  newTraining, 
  setNewTraining 
}) => {
  const [currentModule, setCurrentModule] = useState({ title: "", description: "" });
  const [currentLab, setCurrentLab] = useState({ title: "", description: "" });
  const [currentResource, setCurrentResource] = useState({ name: "", description: "" });

  const addModule = () => {
    if (currentModule.title.trim() && currentModule.description.trim()) {
      setNewTraining({
        ...newTraining,
        modules: [...(newTraining.modules || []), currentModule],
      });
      setCurrentModule({ title: "", description: "" });
    }
  };

  const removeModule = (index: number) => {
    setNewTraining({
      ...newTraining,
      modules: (newTraining.modules || []).filter((_, i) => i !== index),
    });
  };

  const addLab = () => {
    if (currentLab.title.trim() && currentLab.description.trim()) {
      setNewTraining({
        ...newTraining,
        labs: [...(newTraining.labs || []), currentLab],
      });
      setCurrentLab({ title: "", description: "" });
    }
  };

  const removeLab = (index: number) => {
    setNewTraining({
      ...newTraining,
      labs: (newTraining.labs || []).filter((_, i) => i !== index),
    });
  };

  const addResource = () => {
    if (currentResource.name.trim() && currentResource.description.trim()) {
      setNewTraining({
        ...newTraining,
        resources: [...(newTraining.resources || []), currentResource],
      });
      setCurrentResource({ name: "", description: "" });
    }
  };

  const removeResource = (index: number) => {
    setNewTraining({
      ...newTraining,
      resources: (newTraining.resources || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Modules</h3>
        <div className="space-y-2">
          <Input
            placeholder="Module Title"
            value={currentModule.title}
            onChange={(e) => setCurrentModule({ ...currentModule, title: e.target.value })}
          />
          <Input
            placeholder="Module Description"
            value={currentModule.description}
            onChange={(e) => setCurrentModule({ ...currentModule, description: e.target.value })}
          />
          <Button type="button" onClick={addModule}>
            Add Module
          </Button>
        </div>
        <ul className="mt-2 space-y-1">
          {newTraining.modules?.map((module, index) => (
            <li key={index} className="flex justify-between items-center">
              <div>
                <strong>{module.title}</strong>: {module.description}
              </div>
              <Button variant="ghost" size="sm" onClick={() => removeModule(index)}>
                Remove
              </Button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="text-lg font-semibold">Labs</h3>
        <div className="space-y-2">
          <Input
            placeholder="Lab Title"
            value={currentLab.title}
            onChange={(e) => setCurrentLab({ ...currentLab, title: e.target.value })}
          />
          <Input
            placeholder="Lab Description"
            value={currentLab.description}
            onChange={(e) => setCurrentLab({ ...currentLab, description: e.target.value })}
          />
          <Button type="button" onClick={addLab}>
            Add Lab
          </Button>
        </div>
        <ul className="mt-2 space-y-1">
          {newTraining.labs?.map((lab, index) => (
            <li key={index} className="flex justify-between items-center">
              <div>
                <strong>{lab.title}</strong>: {lab.description}
              </div>
              <Button variant="ghost" size="sm" onClick={() => removeLab(index)}>
                Remove
              </Button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="text-lg font-semibold">Resources</h3>
        <div className="space-y-2">
          <Input
            placeholder="Resource Name"
            value={currentResource.name}
            onChange={(e) => setCurrentResource({ ...currentResource, name: e.target.value })}
          />
          <Input
            placeholder="Resource Description"
            value={currentResource.description}
            onChange={(e) => setCurrentResource({ ...currentResource, description: e.target.value })}
          />
          <Button type="button" onClick={addResource}>
            Add Resource
          </Button>
        </div>
        <ul className="mt-2 space-y-1">
          {newTraining.resources?.map((resource, index) => (
            <li key={index} className="flex justify-between items-center">
              <div>
                <strong>{resource.name}</strong>: {resource.description}
              </div>
              <Button variant="ghost" size="sm" onClick={() => removeResource(index)}>
                Remove
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdditionalDetailsStep;